import script from "./EmployeeProjectDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmployeeProjectDetails.vue?vue&type=script&setup=true&lang=ts"

import "./EmployeeProjectDetails.vue?vue&type=style&index=0&id=0f5079b1&scoped=true&lang=css"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f5079b1"]])

export default __exports__